import { make } from 'vuex-pathify'
import Project from '@/api/project'

const defaultProject = {
  files: [],
  tasks: [],
  places: [],
  promotions: []
}

const state = {
  project: {
    ...defaultProject
  }
}

const getters = {
  ...make.getters(state),

  applicationFiles(state) {
    return state.project.files.filter(function(item) {
      return item.category === 'application'
    })
  },

  referenceFiles(state) {
    return state.project.files.filter(function(item) {
      return item.category === 'reference'
    })
  }
}

const mutations = {
  ...make.mutations(state)
}

const actions = {
  async store({ commit }, payload) {
    try {
      const response = await Project.store(payload)
      return response
    } catch (e) {
      return false
    }
  },

  async show({ commit }, { id, params }) {
    try {
      commit('SET_PROJECT', {
        ...defaultProject
      })
      const response = await Project.show(id, params)
      commit('SET_PROJECT', response.data.project)
      return response.data
    } catch (e) {
      return false
    }
  },

  async update({ commit }, payload) {
    try {
      const response = await Project.update(payload.id, payload)
      return response
    } catch (e) {
      return false
    }
  },

  async delete({ commit }, id) {
    try {
      const response = await Project.delete(id)
      return response
    } catch (e) {
      return false
    }
  },

  async complete({ commit }, payload) {
    try {
      const response = await Project.complete(payload.id, payload)
      return response
    } catch (e) {
      return false
    }
  },

  async adminReview({ commit }, payload) {
    try {
      const response = await Project.adminReview(payload.id, payload)
      return response
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
